module.exports = __webpack_public_path__ + "assets/spaneq.1354c93a.svg";